export default [
  {
    path: '/real-estate-developments/:id/characteristics/new',
    name: 'RealEstateDevelopmentsCharacteristicsCreate',
    component: () => import('pages/real-estate-developments/tabs/characteristics/CharacteristicsForm.vue')
  },
  {
    path: '/real-estate-developments/:parentId/characteristics/:id/edit',
    name: 'RealEstateDevelopmentsCharacteristicsEdit',
    component: () => import('pages/real-estate-developments/tabs/characteristics/CharacteristicsForm.vue')
  }
]
